<template>
  <el-dialog
    title="选择擅长专业"
    :visible.sync="centerDialogVisible2"
    width="30%"
    center
    v-if="centerDialogVisible2"
  >
    <el-tree
      :data="listSubconBaseSubjectList"
      :props="props"
      show-checkbox
      node-key="subjectCode"
      ref="tree"
      @check-change="handleTreeCheckChange"
    >
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible2 = false">取 消</el-button>
      <el-button type="primary" @click="getTreeItems">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ProfessionalCategory",
  data() {
    return {
      listSubconBaseSubjectList: [],
      props: {
        label: "subjectName",
        children: "children"
        // disabled: data => {// 选项禁用
        //   return data.isSelected == "0";
        // }
      },
      centerDialogVisible2: false,
      // 主要业务的下的某通用工程的id
      nodeKeys: [],
      // 被选中节点的key
      checkedSubjectCodes: [],
      // 被选中节点的名称
      checkedSubjectNames: []
    };
  },
  mounted() {
    this.listSubconBaseSubjectList = JSON.parse(localStorage.getItem("ywlb"));
    console.log(this.listSubconBaseSubjectList,'0000000000')
  },
  methods: {
    // 擅长专业--当复选框被点击的时候触发
    handleTreeCheckChange(data, isChecked) {
      if (isChecked) {
        // 节点被选中
        if (data.attribute2 == 2 && data.level == 1) {
          //选中的是通用工程且是第一级别
          // 则主要业务下的该项也被选中
          this.filterNode(this.listSubconBaseSubjectList, data.subjectName);
          this.nodeKeys.forEach(item => {
            this.$refs.tree.setChecked(item, true, true);
          });
        }
      } else {
        if (data.attribute2 == 2 && data.level == 1) {
          //取消选中的是通用工程且是第一级别
          // 则主要业务下的该项也取消选中
          this.filterNode(this.listSubconBaseSubjectList, data.subjectName);
          this.nodeKeys.forEach(item => {
            this.$refs.tree.setChecked(item, false);
          });
        }
      }
      this.nodeKeys = [];
    },
    // 过滤主要业务下的某通用工程
    filterNode(data, name) {
      data.forEach(item => {
        if (item.subjectName == name && item.attribute2 == "3") {
          //主要业务下的通用工程
          this.nodeKeys.push(item.subjectCode);
        }
        if (item.children && item.children.length > 0) {
          this.filterNode(item.children, name);
        }
      });
    },
    // 擅长专业弹框的确定按钮
    getTreeItems() {
      this.checkedSubjectCodes = this.$refs.tree.getCheckedKeys(); //选中节点的key
      // this.nodeKeys = [];
      if (!this.checkedSubjectCodes.length) {
        this.$message({
          type: "warning",
          showClose: true,
          message: "请选中至少一个擅长专业进行搜索",
          ccuiCustom: true
        });
        return false;
      }
      this.checkedSubjectNames = [];
      const arr = this.$refs.tree.getCheckedNodes(); // 选中节点
      arr.forEach(item => {
        this.getTreeNode(item);
      });
      console.log(this.checkedSubjectNames);
      this.$emit(
        "getProfessions",
        this.checkedSubjectCodes,
        this.checkedSubjectNames.join(",")
      );
      this.centerDialogVisible2 = false;
    },
    // 获取选中节点父级节点数据（选中节点的名称全路径）
    getTreeNode(data) {
      data.subjectName1 = data.subjectName1
        ? data.subjectName1
        : data.subjectName;
      if (data.parentCode) {
        // 获取父节点
        let pNode = this.$refs.tree.getNode(data.parentCode);
        pNode.data.subjectName1 =
          pNode.data.subjectName + "/" + data.subjectName1;
        this.getTreeNode(pNode.data);
      } else {
        this.checkedSubjectNames.push(data.subjectName1);
      }
    }
  }
};
</script>

<style scoped></style>
